import {
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { CheckboxValueType } from '../../../types/filter.type';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { Chip } from '../../chip/chip';
import { ColorService } from '../../../services/color.service';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-checkbox-menu-element',
  imports: [TranslateModule, IconComponent, Chip],
  templateUrl: './checkbox-menu-element.html',
  styleUrl: './checkbox-menu-element.scss',
})
export class CheckboxMenuElement {
  colorService: ColorService = inject(ColorService);

  column: InputSignal<string> = input.required<string>();
  data: InputSignal<CheckboxValueType> = input.required<CheckboxValueType>();
  iconUrl: Signal<string | undefined> = computed(() => this.data().iconUrl);
  valueChange: OutputEmitterRef<boolean> = output<boolean>();

  setCheckboxValue(checked: boolean): void {
    this.valueChange.emit(checked);
  }
}
